import { motion } from "framer-motion";
import { useLocation, Link } from "react-router-dom";

function NavComponents() {
  const location = useLocation();
  
  // Check if the current path matches the link path
  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <nav className="flex items-center space-x-1">
      {/* Features link */}
      <motion.div
        className="relative"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 400, damping: 17 }}
      >
        <Link
          to="/features"
          className={`px-4 py-2 rounded-md font-medium text-sm relative group overflow-hidden block ${
            isActive('/features') 
              ? 'text-[#ff8c42]' 
              : 'text-[#694e42]'
          }`}
          aria-current={isActive('/features') ? 'page' : undefined}
        >
          <span className="relative z-10">Features</span>
          <span 
            className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-[#ff8c42] to-[#694e42] transition-all duration-300 ${
              isActive('/features') ? 'w-full' : 'w-0 group-hover:w-full'
            }`}
          ></span>
        </Link>
      </motion.div>

      {/* Pricing link */}
      <motion.div
        className="relative"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 400, damping: 17 }}
      >
        <Link
          to="/pricing"
          className={`px-4 py-2 rounded-md font-medium text-sm relative group overflow-hidden block ${
            isActive('/pricing') 
              ? 'text-[#ff8c42]' 
              : 'text-[#694e42]'
          }`}
          aria-current={isActive('/pricing') ? 'page' : undefined}
        >
          <span className="relative z-10">Pricing</span>
          <span 
            className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-[#ff8c42] to-[#694e42] transition-all duration-300 ${
              isActive('/pricing') ? 'w-full' : 'w-0 group-hover:w-full'
            }`}
          ></span>
        </Link>
      </motion.div>

      {/* Resources link */}
      <motion.div
        className="relative"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 400, damping: 17 }}
      >
        <Link
          to="/resources"
          className={`px-4 py-2 rounded-md font-medium text-sm relative group overflow-hidden block ${
            isActive('/resources') 
              ? 'text-[#ff8c42]' 
              : 'text-[#694e42]'
          }`}
          aria-current={isActive('/resources') ? 'page' : undefined}
        >
          <span className="relative z-10">Resources</span>
          <span 
            className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-[#ff8c42] to-[#694e42] transition-all duration-300 ${
              isActive('/resources') ? 'w-full' : 'w-0 group-hover:w-full'
            }`}
          ></span>
        </Link>
      </motion.div>
    </nav>
  );
}

export default NavComponents;
